































































































































































import Vue from "vue";
import InformationCard from "@/features/information/components/information-card.vue";

export default Vue.extend({
  props: {
    title: {
      type: String,
      default: "Champs libre",
    },
    items: {
      type: Array,
      default: () => [],
    },
    champsLibres: {
      type: Array,
      default: () => [],
    },
    champsLibresResult: {
      type: Array,
      default: () => [],
    },
    champsLibresResultsValeurs: {
      type: Array,
      default: () => [],
    },
    champsLibresValeurs: {
      type: Array,
      default: () => [],
    },
  },
  filters: {
    dateFilter(val: string) {
      if (typeof val === "undefined" || val.length < 1) return "";
      let onlyDate = val.split(" ")[0];
      return onlyDate.split("-").reverse().join("-");
    },
  },
  components: {
    InformationCard,
  },
});
